export const GetHeightMenuFixed = ({ gap }: { gap: any }) => {
  const heightGap = gap ? gap.getBoundingClientRect().height : 900;

  return `${document.body.getBoundingClientRect().height - heightGap}px`;
};
